import * as yup from 'yup';

import i18n from '@app/i18n/config';

import { onlyCyrillic, onlyLetters } from '@shared/regexps';

export const getDefaultFioSchema = (firstLetterError: string) =>
  yup
    .string()
    .required(i18n.t('COMMON:errors.required'))
    .min(1, i18n.t('COMMON:errors.minLength'))
    .max(50, i18n.t('COMMON:errors.maxLength'))
    .matches(onlyLetters, firstLetterError)
    .matches(onlyCyrillic, i18n.t('COMMON:errors.useCyrillic'));

export const lastNameSchema = getDefaultFioSchema(
  i18n.t('COMMON:errors.lastnameStartWithLetter')
);
export const firstNameSchema = getDefaultFioSchema(
  i18n.t('COMMON:errors.nameStartWithLetter')
);

const middleNameSchema = yup.string().when('noMiddleName', {
  is: false,
  then: () =>
    getDefaultFioSchema(i18n.t('COMMON:errors.middleNameStartWithLetter')),
});

export const fioSchema = yup
  .object()
  .shape({
    lastName: lastNameSchema,
    firstName: firstNameSchema,
    middleName: middleNameSchema,
    noMiddleName: yup.boolean(),
  })
  .required();
